import type { CarMissingInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/missingInformation/';
import { CheckboxField, NumberField, GridItem, Box, Grid } from '@flos/react-ui';
import { useRecoilState } from 'recoil';
import { missingInformationAtom } from '../../../recoil/atoms/missingInformationAtom';
import { useHippoText } from '../../../hooks/useHippoText';
import { FieldBox } from './missingInformationCoverables/FieldBox';

const CarMissingInformationForm = ({
    carMissingDTO
}: {
    carMissingDTO: CarMissingInformationDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [missingInformation, setMissingInformation] = useRecoilState(missingInformationAtom);
    const { fixedId, registrationNumber, odometerReading, hasOdometer } = carMissingDTO;
    const odometerChecked = hasOdometer === undefined ? false : !hasOdometer;

    const updateMissingInformationProperty = (updateValue: object): void => {
        const updateValueWithRegNumber = { registrationNumber, ...updateValue };
        const updateCar = missingInformation.car?.map((item) => {
            if (item.fixedId !== fixedId) return item;
            return {
                ...item,
                ...updateValueWithRegNumber
            };
        });
        setMissingInformation((previousState) => {
            return {
                ...previousState,
                car: updateCar
            };
        });
    };

    return (
        <Box>
            <Grid gap={4}>
                <GridItem span={12}>
                    <h6>Bilforsikring</h6>
                </GridItem>
                <FieldBox label={registrationNumber}>
                    <NumberField
                        key={`${fixedId ?? ''}${hasOdometer?.toString() ?? ''}`}
                        maxLength={10}
                        label={getHippoText(
                            'DSS-CHECKOUT-ADDITIONAL-INFORMATION-ODOMETER-READING-FIELD'
                        )}
                        disabled={odometerChecked}
                        value={hasOdometer ? odometerReading?.toString() : ''}
                        onBlur={(data) => {
                            updateMissingInformationProperty({
                                hasOdometer: true,
                                odometerReading: data.currentTarget.value
                            });
                        }}
                    />
                    <CheckboxField
                        label={getHippoText(
                            'DSS-CHECKOUT-ADDITIONAL-INFORMATION-ODOMETER-READING-CHECKMARK'
                        )}
                        defaultChecked={odometerChecked}
                        onChange={(event) => {
                            const checked = event.target.checked;
                            updateMissingInformationProperty({
                                odometerReading: checked ? undefined : odometerReading,
                                hasOdometer: !checked
                            });
                        }}
                    />
                </FieldBox>
            </Grid>
        </Box>
    );
};
export default CarMissingInformationForm;
